import * as React from 'react';

import { useObserver } from 'src/hooks/useObserver';

// Return TRUE to continue observing. FALSE to disconnect. Defaults to TRUE
type VisibleCallback = (details: { visible: boolean }) => boolean | void;

export function useVisible(callback: VisibleCallback) {
  const observer = React.useMemo(() => {
    return new IntersectionObserver(([entry], self) => {
      const continueObserving = callback({ visible: entry.isIntersecting });
      if (continueObserving === false) {
        self.disconnect();
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    });
  }, [callback]);

  return useObserver(observer);
}
